<template>
	<div class="page" :style="[pageDiv]">
		<!-- <Tip :tip="tip" /> -->
		<div class="step">
			<el-steps :active="step">
				<el-step title="选择业务类型" description="第1步"></el-step>
				<el-step title="填写申请并提交" description="第2步"></el-step>
				<el-step title="审批人处理" description="第3步"></el-step>
				<el-step title="完结" description="第4步"></el-step>
			</el-steps>
		</div>
		<div class="template_div" v-if="templateList.length">
			<el-radio v-model="form.template_id" :label="item.id" v-for="(item,index) in templateList"
				@change="radioChange">{{item.name}}</el-radio>
		</div>
		<div class="from_div" :style="[fromDiv]">
			<!--自定义表单-->
			<CstomForm ref="form" :disabled="step != 1 ? true : false" :TemplateList="form.template_form"
				:customObj="customObj" />
			<!--业务表单-->
			<!--审批流程图-->
			<div v-if="(typeof(this.type) !== 'undefined')" class="col">
				<el-divider/>
				<WorkFlow :list="list"/>
			</div>
		</div>
		<div class="foot_div" :style="[footDiv]">
			<el-input v-if="operateBoolean && step < 4" class="input" v-model="remark" placeholder="请输入处理备注信息" />
			<el-button v-if="operateBoolean && step < 4" type="success" @click="audit(form.apply_id,2)">审核通过</el-button>
			<el-button v-if="operateBoolean && step < 4" type="danger" @click="audit(form.apply_id,3)">审核拒绝</el-button>
			<el-button v-if="(typeof(this.type) !== 'undefined')" @click="close">返回</el-button>
			<el-button v-if="step == 1" type="primary" @click="submitForm">确定</el-button>
		</div>
	</div>
</template>

<script>
	import Tip from "../../../components/Tip/Tip.vue"
	import CstomForm from "../../../components/CustomForm/CustomForm.vue"
	import WorkFlow from "../../../components/WorkFlow/WorkFlow.vue"
	import {
		oaTemplate,
		oaApply,
		oaAudit
	} from "../../../request/apis.js"
	import {
		mapGetters
	} from 'vuex'
	export default {
		props: {
			type: {
				type: Number
			}
		},
		components: {
			Tip,
			CstomForm,
			WorkFlow
		},
		data() {
			return {
				tip: '由各岗位根据日常业务的权限及处理情况，发起申请。',
				step: 1, //进度
				templateList: [], //自定义表单列表
				customObj: {
					tempName: '', //表单名称
					tempTime: '', //提交时间
					tempNum: '', //申请单号
					tempAcc: '', //操作账号
				},
				form: {
					template_id: '', //表单id
					template_form: [] //表单模板
				},
				operateBoolean: false, //是否有审批权限
				list:[],//审批流程
				remark: '' //备注
			}
		},
		computed: {
			pageDiv() {
				return {
					'position': typeof(this.type) !== 'undefined' ? 'relative' : ''
				}
			},
			fromDiv() {
				return {
					'overflow': typeof(this.type) !== 'undefined' ? 'scroll' : '',
					'height': typeof(this.type) !== 'undefined' ? '515px' : '',
					'min-height': typeof(this.type) !== 'undefined' ? '100%' : '',
					'padding-bottom': typeof(this.type) !== 'undefined' ? '66px' : '',
				}
			},
			footDiv() {
				return {
					'margin-left': typeof(this.type) !== 'undefined' ? '' : '66px'
				}
			},
			...mapGetters(['loginInfo']),
		},
		mounted() {
			if (typeof(this.type) !== 'undefined') {
				this.form.apply_id = this.type;
				this.template_form = [];
				this.getOaApplyDetail();
			} else {
				this.getOaTemplateList();
			}
		},
		methods: {

			//获取提审详情
			getOaApplyDetail() {
				oaApply({ apply_id: this.form.apply_id }, 3).then(res => {
					if (res.code == 0) {
                        // this.loginInfo.admin_id是否在res.data.current_node_admin_id数组内
						this.operateBoolean = res.data.current_node_admin_id.includes(this.loginInfo.admin_id);
						this.step = res.data.audit + 1;
						this.form.template_form = res.data.template_form;
						this.list = res.data.lists;
					}
				}).catch(err => {})
			},

			//获取关联表单列表
			getOaTemplateList() {
				oaTemplate({
					template_type: 2
				}, 4).then(res => {
					if (res.code == 0) {
						var obj = {}
						res.data.forEach((item, index) => {
							obj = {
								name: item.template_name,
								id: item.template_id,
								form: JSON.parse(item.template_form)
							}
							this.templateList.push(obj)
						})
						this.radioChange(this.templateList[0].id);
					}
				}).catch(err => {})
			},

			//切换radio
			radioChange(val) {
				var index = this.templateList.findIndex(item => item.id == val);
				this.form.template_id = this.templateList[index].id
				this.form.template_form = this.templateList[index].form
				this.customObj.tempName = this.templateList[index].name;
				this.customObj.tempTime = '';
				this.customObj.tempNum = '';
				this.customObj.tempAcc = '';
			},

			//提交表单
			submitForm() {
				var type = typeof(this.type) !== 'undefined' ? 4 : 0
				oaApply({ ...this.form }, type).then(res => {
					if (res.code == 0) {
						this.$emit('close', 0)
						this.$message.success(res.msg);
					} else {
						this.$message.error(res.msg);
					}
				}).catch(err => {})
			},

			//审核人员审核
			audit(apply_id, audit) {
				oaAudit({
					apply_id: apply_id,
					audit:audit,
					remark:this.remark
				}, 0).then(res=>{
					if(res.code == 0){
						this.$message.success(res.msg);
						this.$emit('close', 0)
					}else{
						this.$message.error(res.msg);
					}
				}).catch(err=>{})
			},

			close() {
				this.$emit('close', 1)
			}
		}
	}
</script>

<style scoped>
	.page {
		margin-bottom: 66px;
		min-height: -webkit-fill-available;
	}

	.step {
		margin-top: 20px;
	}

	.input {
		width: 250px;
		margin-right: 20px;
	}

	.el-step.is-horizontal {
		margin-right: 50%;
	}

	.template_div {
		margin-top: 20px;
		padding: 20px;
		border-radius: 5px;
		border: 1px solid #eee;
	}

	.from_div {
		margin-top: 20px;
		width: 100%;
	}

	.foot_div {
		position: absolute;
		bottom: 0;
		left: 0;
		width: calc(100% - 120px);
		padding: 0 60px;
		line-height: 66px;
		height: 66px;
		background: #fff;
		box-shadow: 0px -4px 10px -5px rgba(0, 0, 0, 0.3);
		border-radius: 0 0 10px 10px;
	}
</style>